import type { Coordinates } from '@freedom/shared';

export const MAP_TOOL_IDS = ['select', 'site', 'base_station', 'client', 'ptp', 'ptmp', 'obstacle', 'measure'] as const;

export type MapToolId = typeof MAP_TOOL_IDS[number];

export interface TwoPointMapDraft {
  start: Coordinates | null;
  preview: Coordinates | null;
}

export interface CompletedTwoPointMapDraft {
  points: [Coordinates, Coordinates] | null;
  draft: TwoPointMapDraft;
}

function cloneCoordinates(point: Coordinates): Coordinates {
  return { lat: point.lat, lon: point.lon };
}

export function nextMapTool(current: MapToolId, requested: MapToolId): MapToolId {
  return current === requested && requested !== 'select' ? 'select' : requested;
}

export function cancelMapTool(): MapToolId {
  return 'select';
}

export function mapToolCursor(tool: MapToolId): 'default' | 'crosshair' {
  return tool === 'select' ? 'default' : 'crosshair';
}

export function emptyTwoPointMapDraft(): TwoPointMapDraft {
  return { start: null, preview: null };
}

export function beginTwoPointMapDraft(point: Coordinates): TwoPointMapDraft {
  const start = cloneCoordinates(point);
  return { start, preview: cloneCoordinates(point) };
}

export function previewTwoPointMapDraft(draft: TwoPointMapDraft, point: Coordinates): TwoPointMapDraft {
  if (!draft.start) return draft;
  return { start: cloneCoordinates(draft.start), preview: cloneCoordinates(point) };
}

export function completeTwoPointMapDraft(draft: TwoPointMapDraft, end: Coordinates): CompletedTwoPointMapDraft {
  return {
    points: draft.start ? [cloneCoordinates(draft.start), cloneCoordinates(end)] : null,
    draft: emptyTwoPointMapDraft(),
  };
}
